import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
@Component({
  selector: 'formly-chapter',
  template: `
    @if (field.templateOptions?.chapterHr) {
      <hr />
    }
    <h3
      style="display:inline"
      [innerText]="field.templateOptions?.chapterTitle || ''"
      #tooltip="matTooltip"
      [matTooltip]="field.templateOptions?.tooltip"
    ></h3>
    @if (field.templateOptions?.tooltip) {
      <button mat-button color="accent" type="button" (click)="tooltip.toggle()">
        <mat-icon>help_outline</mat-icon>
      </button>
    }
    <p [innerText]="field.templateOptions?.chapterText || ''"></p>
  `,
  standalone: false,
})
export class FormlyChapterComponent extends FieldType {}
